import * as React from 'react';
import { Prompt } from 'react-router';
import { Tabs, Col, Row, Badge } from 'antd';
import { observer } from 'mobx-react';
const TabPane = Tabs.TabPane;

import { DocumentGenerationController } from 'src/app/general/document-generation/document-generation.controller';
import { HeaderView } from 'src/app/shared/header.view';
import { ExtendedSchemaView } from 'src/core/ui/extended-schema.view';
import { ClientCommonPartController } from './parts/clientcommon-part.controller';
import { ClientGeneralPartController } from './parts/clientgeneral-part.controller';
import { ClientContactPart } from './parts/clientcontact-part';
import { ClientContactController } from './parts/client-contact.controller';
import { NoteListController } from 'src/app/general/notes/list/note-list.controller';
import { ClientQuoteListController } from 'src/app/crm/clients/form/parts/client-quote-list.controller';
import UserTaskTab from 'src/app/general/user-tasks/parts/user-tasks-tab.view';
import * as moment from 'moment';

interface ClientFormViewProps extends ComponentViewProps<ClientItem> {
	title: string,
	save: () => void,
	cancel: () => void,
	model: ClientItem;
	schema: JsonSchema;
	mode: ControlMode;
	onModeChange: (mode: ControlMode) => void;
	contextService: any;
	identityService: any;
	isNew: boolean;
	history?: any;
	offset?: boolean;
	showHeader?: boolean;
	className?: boolean;
	quoteDataSet?: DataSet<QuoteSummary>;
}

@observer
export class ClientFormView extends React.Component<ClientFormViewProps, { userTaskCount: number }> {
	constructor(props: Readonly<ClientFormViewProps>) {
		super(props);

		this.state = {
			userTaskCount: 0
		}
	}

	componentDidMount(): void {
		let daedline = moment.utc().add(1, "day").toDate();
		let assignedToId = this.props.identityService.userId;
		let priority = 1;
		let titleTask = "Task Title";
		this.taskTab = new UserTaskTab(this, this.props.model.id, 'client', this.props.setBusy, daedline, assignedToId, priority, titleTask);
	}

	private get hasExtendedProperties(): boolean {
		return this.props.schema.allOf != null && this.props.schema.allOf.length > 0 && Object.getOwnPropertyNames(this.props.schema.allOf[0].properties).length > 0;
	}

	private renderNotesCard() {
		return (
			<div className="card">
				<h2>Latest notes</h2>
				<NoteListController
					isModal={false}
					model={this.props.model.dynamicProperties['notes']}
					mode={this.props.mode}
					identityService={this.props.identityService}
					setBusy={this.props.setBusy} />
			</div>
		);
	}

	taskTab: UserTaskTab;

	render(): React.ReactNode {
		if (this.props.model == null) {
			return null;
		}

		return (
			<div className={(this.props.className == null || this.props.className == true) ? "window window-normal" : ""}>
				<Prompt
					when={this.props.contextService.isDirty}
					message={location => `If you go to ${location.pathname}, all changes will be lost. Are you sure you want to continue?`}
				/>
				<Row>
					<Col xs={24} lg={this.props.offset != null && this.props.offset == false ? 24 : { offset: 3, span: 18 }}>
						{(this.props.showHeader == null || this.props.showHeader == true) && <Row>
							<Col xs={24}>
								<HeaderView
									title={this.props.title}
									mode={this.props.mode}
									onModeChanged={this.props.onModeChange}
									save={this.props.save}
									cancel={this.props.cancel}
									contextService={this.props.contextService}
								/>
							</Col>
						</Row>}
						<Row>
							<Col xs={24}>
								<div className="card p-3 card-borderless">
									<Tabs defaultActiveKey="General information">
										<TabPane tab={<span>General information</span>} key="General information">
											<Row gutter={16}>
												<Col xs={24} lg={16}>
													<ClientGeneralPartController
														mode={this.props.mode}
														onModeChanged={this.props.onModeChange}
														model={this.props.model}
														setBusy={this.props.setBusy}
													/>
												</Col>
												<Col xs={24} lg={8}>
													<ClientCommonPartController
														mode={this.props.mode}
														onModeChanged={this.props.onModeChange}
														model={this.props.model}
														setBusy={this.props.setBusy}
													/>
												</Col>
											</Row>
										</TabPane>
										<TabPane tab={<span>Contact information</span>} key="Contact information">
											<Row gutter={16}>
												<Col xs={24} lg={16}>
													<ClientContactPart
														parentModel={this.props.model}
														mode={this.props.mode}
														model={this.props.model.dynamicProperties["contacts"]}
														setBusy={this.props.setBusy}
														contextService={this.props.contextService}
													/>
												</Col>
												<Col xs={24} lg={8}>
													<ClientContactController
														mode={this.props.mode}
														onModeChanged={this.props.onModeChange}
														model={this.props.model}
														setBusy={this.props.setBusy}
													/>
												</Col>
											</Row>
										</TabPane>
										<TabPane tab={<span>Notes</span>} key="Notes">
											{this.renderNotesCard()}
										</TabPane>
										{this.taskTab && this.taskTab.render()}
										{
											this.hasExtendedProperties &&
											<TabPane tab={<span>Other Properties</span>} key="Other Properties">
												<ExtendedSchemaView
													mode={this.props.mode}
													columns={2}
													model={this.props.model.dynamicProperties}
													schema={this.props.schema}
													setBusy={this.props.setBusy}
													title="Other Information"
												/>
											</TabPane>
										}
										{
											!this.props.isNew &&
											<TabPane tab={<span>Documents</span>} key="documents">
												<DocumentGenerationController
													contextService={this.props.contextService}
													containerId={this.props.model.documentsLibraryId}
													setBusy={this.props.setBusy}
													usage="Clients"
													targetId={this.props.model.id}
												/>
											</TabPane>
										}
										{
											!this.props.isNew &&
											<TabPane tab={<Badge style={{ right: '-15px', marginTop: '5px' }} count={this.props.quoteDataSet.count}><span>Quotes</span></Badge>} key="quotes">
												<Row gutter={16}>
													<Col xs={24} md={24}>
														<ClientQuoteListController
															model={this.props.quoteDataSet}
															setBusy={this.props.setBusy}
															history={this.props.history}
															mode={this.props.mode}
														/>
													</Col>
												</Row>
											</TabPane>
										}
									</Tabs>
								</div>
							</Col>
						</Row>
					</Col>
				</Row>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/crm/clients/form/client-form.view.tsx